{
  "pad": {
    "label": "توقيع العميل",
    "canvas": "منطقة التوقيع: وقّع بالإصبع أو بالقلم أو بالفأرة",
    "here": "وقّع هنا",
    "clear": "مسح",
    "hint": "اختياري: يكفي اسم العميل المكتوب. يُحفظ التوقيع المرسوم هنا مع السجل دليلاً.",
    "signed": "تم التقاط التوقيع"
  },
  "upload": {
    "failed": "تعذّر حفظ التوقيع. أرفق صورة للورقة الموقّعة بدلاً منه."
  },
  "sign": {
    "name": "الاسم",
    "signature": "التوقيع",
    "date": "التاريخ",
    "customerSignature": "توقيع العميل"
  },
  "estimate": {
    "title": "عرض سعر خدمة",
    "show": "إظهار عرض السعر",
    "showHint": "يُفتح في علامة تبويب جديدة لعرضه على العميل أو طباعته.",
    "back": "العودة إلى أمر الخدمة",
    "agreement": "الموافقة على السعر",
    "notAgreed": "لم تتم الموافقة بعد",
    "version": "v{{n}} · {{status}}",
    "date": "التاريخ",
    "preparedFor": "مُعدّ لـ",
    "customerCode": "رمز العميل",
    "location": "موقع الخدمة",
    "contact": "جهة الاتصال في الموقع",
    "problem": "المشكلة المبلّغ عنها",
    "requested": "الخدمة المطلوبة",
    "items": "البنود المدفوعة",
    "noItems": "لا بنود مدفوعة بعد.",
    "covered": "مشمول بالعقد",
    "coveredRef": "مشمول بالعقد {{reference}}",
    "coveredNote": "بلا رسوم: هذه البنود مشمولة بعقد الخدمة.",
    "quantity": "الكمية",
    "item": "البند",
    "acceptance": "موافقة العميل",
    "statement": "أوافق على العمل والأسعار الواردة في عرض السعر هذا.",
    "acceptedBy": "وافق عليه {{name}} بتاريخ {{date}} ({{method}}).",
    "footer": "المبالغ بالريال العُماني (<rial/>). أي تغيير في البنود يحتاج إلى موافقة جديدة."
  },
  "report": {
    "title": "تقرير الزيارة",
    "open": "تقرير الزيارة",
    "back": "العودة إلى الزيارة",
    "kind": "الزيارة",
    "date": "التاريخ",
    "window": "الوقت",
    "arrived": "الوصول",
    "finished": "الانتهاء",
    "team": "الفريق",
    "lead": "قائد الزيارة",
    "customer": "العميل",
    "location": "الموقع",
    "contact": "جهة الاتصال في الموقع",
    "problem": "المشكلة المبلّغ عنها",
    "planned": "زيارة وقائية",
    "work": "البنود المنفذة في هذه الزيارة",
    "noWork": "لم يُسجَّل عمل في هذه الزيارة.",
    "item": "البند",
    "done": "المنجز في هذه الزيارة",
    "ofTotal": "من {{quantity}}",
    "outcome": "النتيجة",
    "findings": "التقرير",
    "noReport": "لم يُكتب تقرير.",
    "photos": "الصور",
    "morePhotos_zero": "لا صور أخرى مرفقة بالزيارة.",
    "morePhotos_one": "صورة أخرى واحدة مرفقة بالزيارة.",
    "morePhotos_two": "صورتان أخريان مرفقتان بالزيارة.",
    "morePhotos_few": "{{n}} صور أخرى مرفقة بالزيارة.",
    "morePhotos_many": "{{n}} صورة أخرى مرفقة بالزيارة.",
    "morePhotos_other": "{{n}} صورة أخرى مرفقة بالزيارة.",
    "acknowledgment": "إقرار العميل",
    "statement": "حضر الفريق هذه الزيارة كما هو موصوف أعلاه.",
    "notFinished": "لم تنتهِ هذه الزيارة بعد: التقرير غير نهائي.",
    "footer": "سجلّ للزيارة، وليس فاتورة.",
    "checks": {
      "title": "المعدات التي فُحصت",
      "done": "تم: {{n}}",
      "issues_zero": "وُجد عطل: {{n}}",
      "issues_one": "وُجد عطل: {{n}}",
      "issues_two": "وُجد عطل: {{n}}",
      "issues_few": "وُجد عطل: {{n}}",
      "issues_many": "وُجد عطل: {{n}}",
      "issues_other": "وُجد عطل: {{n}}",
      "noAccess": "تعذّر الوصول: {{n}}",
      "skipped": "تم التخطي: {{n}}",
      "notChecked_zero": "فُحصت كل المعدات في أماكن هذه الزيارة.",
      "notChecked_one": "لم تُفحص معدة واحدة في أماكن هذه الزيارة.",
      "notChecked_two": "لم تُفحص معدتان في أماكن هذه الزيارة.",
      "notChecked_few": "لم تُفحص {{n}} معدات في أماكن هذه الزيارة.",
      "notChecked_many": "لم تُفحص {{n}} معدة في أماكن هذه الزيارة.",
      "notChecked_other": "لم تُفحص {{n}} معدة في أماكن هذه الزيارة.",
      "placeCount_zero": "لا معدات",
      "placeCount_one": "معدة واحدة",
      "placeCount_two": "معدتان",
      "placeCount_few": "{{n}} معدات",
      "placeCount_many": "{{n}} معدة",
      "placeCount_other": "{{n}} معدة",
      "tag": "الرمز",
      "type": "النوع",
      "position": "الموضع",
      "outcome": "النتيجة",
      "readings": "القراءات والفحوص",
      "note": "ملاحظة",
      "reason": "السبب:",
      "faultJob": "أمر العطل"
    }
  }
}
